import React from 'react';
import type { RealestateAd, RealestateProjectAd } from '../../../types';
import { useSearchAdClasses } from '../SearchAdClasses';
import { useSearchAdContext } from '../SearchAdContext';

const classes = {
    mobile: {
        organization: 'flex items-center',
        organizationHiddenOnMobile: '',
        logo: 'mr-8 max-h-24',
        logoHiddenOnMobile: 'hidden',
    },
    desktop: {
        organizationHiddenOnMobile: 'sm:flex sm:items-center',
        logo: 'sm:mr-16 sm:max-h-40',
        logoHiddenOnMobile: 'sm:block',
    },
};

const logoStyle = { maxWidth: 75 };

type RealestateOrganisationProps = {
    ad: RealestateAd | RealestateProjectAd;
    className?: string;
    hideLogoOnMobile?: boolean;
    isLettingsWanted?: boolean;
    suppressLogo?: boolean;
};

export function RealestateOrganisation(props: RealestateOrganisationProps) {
    const {
        ad,
        className = '',
        suppressLogo = false,
        hideLogoOnMobile = false,
        isLettingsWanted = false,
    } = props;

    const privateLabel = ad.labels
        ?.filter((label) => label.type === 'SECONDARY')
        .find((label) => label.id === 'private');

    const { mode } = useSearchAdContext();
    const c = useSearchAdClasses({
        mode,
        mobileClasses: classes.mobile,
        desktopClasses: classes.desktop,
    });

    return (
        <div
            className={`${className} ${
                hideLogoOnMobile ? c.organizationHiddenOnMobile : c.organization
            }`}
        >
            {ad.logo && !suppressLogo && (
                <img
                    alt=""
                    className={`${c.logo} ${
                        hideLogoOnMobile ? c.logoHiddenOnMobile : ''
                    }`}
                    src={ad.logo.url}
                    style={logoStyle}
                />
            )}
            {ad.organisation_name && (
                <span
                    className={`${
                        suppressLogo ? 'text-s' : 'text-xs'
                    } s-text-subtle`}
                >
                    {ad.organisation_name}
                </span>
            )}
            {!ad.organisation_name && privateLabel && !isLettingsWanted && (
                <span className="text-xs s-text-subtle">
                    {privateLabel.text}
                </span>
            )}
        </div>
    );
}
